import { LocaleDict } from "@/i18n";
import { DimensionsDTO } from "@/lib/shared-types";
import { SortingState } from "@tanstack/react-table";
import { AttachmentPublicUrls } from "./attachment";

export type SellableItemType = "artwork" | "multipleprint" | "tirage";

export interface PaginatedReturn<Data> {
  totalSize: number;
  pageStart: number;
  size: number;
  data: Data[];
}

export interface PagingParameters {
  page: number;
  pageSize: number;
}

export type RelativePosition = {
  position: number;
  total: number;
  nextId?: string;
  previousId?: string;
};

/**
 * Transform a price in cents into a string with fixed length
 */
export const localPrice = (locale: string, price: number) => {
  return (price / 100).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export function sortingToUrlParam(sort: SortingState): string {
  return sort.map((s) => `${s.desc ? "desc" : "asc"}(${s.id})`).toString();
}

export interface BriefSellable {
  id: string;

  itemType: SellableItemType;

  title: string;
  type: string;

  recordingNumber: string;

  displayInfos: string;

  authors: BriefAuthor[];

  previews: AttachmentPublicUrls[];

  createdAt: Date;
  updatedAt: Date | null;
}

export interface CompleteSellable extends BriefSellable {
  technique: LocaleDict;

  dateInfo?: string;

  signature: {
    location: LocaleDict;
    transcript?: string;
  };

  dimensions: DimensionsDTO;
}

export interface BriefAuthor {
  id: string;

  firstName: string;
  lastName: string;

  createdAt: Date;
  updatedAt: Date | null;
}
